import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import { apiGETstructure } from "./crud";
import api from '../../../services/api';

const initialStructureSlice = {
    listLoading: false,
    error: null,
    totalCount: 0,
    entities: [],
}

export const callTypes = {
    list: 'list',
    select: 'select'
}

// Fetch data
export const fetchStructureByFactory = createAsyncThunk('structure/fetchStructure', async (factoryId, { rejectWithValue }) => {
    const response = await apiGETstructure(factoryId);
    if ( response.status === 200 ) {
        return response.data;
    }

    return rejectWithValue(response.data);
})

export async function apiGETUsersSector(factoryId) {
    //$filter=userstructures/any(c : c/structureId+eq+66 or c/structureId+eq+174)
    // var linkdefault = 'odata?$count=true&$select=id, name, sap, email, sectorId ,status&$expand=systemrole($select=Name)&$expand=userDirectSuperior&$expand=userstructures($expand=structure($select=name))&$expand=sector($select=name)&'
    // link.map((i)=>{
    //   linkdefault = linkdefault+i;
    // })
    // const response = (await api.get(`user/${linkdefault}`)).data;
    const response = (await api.get(`user/odata?$filter=factoryId eq ${factoryId} and deparmentId ne null and status eq true&$select=deparmentId`)).data;
    //console.log(response)

    return response
}

//
export const structureSlice = createSlice({
    name: 'structure',
    initialState: initialStructureSlice,
    reducers: {
        //
        catchError: (state, action) => {
            state.error = `${action.type}: ${action.payload.error}`;
            if (action.payload.callType === callTypes.list || action.payload.callType === callTypes.select) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        //
        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list || action.payload.callType === callTypes.select) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        //
        structureFetched: (state, action) => {
            const { totalCount, entities } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = entities;
            state.totalCount = totalCount;
        }
    },
    extraReducers: build => {
        build.addCase(fetchStructureByFactory.fulfilled, (state, action) => {
            state.totalCount = action.payload._count;
            state.entities = action.payload.value;
            //console.log(action.payload);
        })
    }
})

/**
 * Selector structure
 * 
 * @returns {{
 *  listLoading: boolean,
 *  error: undefined,
 *  totalCount: Numbar,
 *  entities: [],
 * }}
 */
export const useStructure = () => useSelector(( state ) => state.structure )